import { render, staticRenderFns } from "./StaticLinks.vue?vue&type=template&id=c35243f0&scoped=true&"
import script from "./StaticLinks.vue?vue&type=script&lang=js&"
export * from "./StaticLinks.vue?vue&type=script&lang=js&"
import style0 from "./StaticLinks.vue?vue&type=style&index=0&id=c35243f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35243f0",
  null
  
)

export default component.exports